const baseURL = 'https://dlg-shopify-hub-aexmgykrbq-uc.a.run.app/api/membership/';

class MembershipActions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const customerEmail = this.getAttribute('data-email');
    if (customerEmail) {
      console.log('customerEmail', customerEmail);
      this.fetchMembershipData(customerEmail);
    }

    const membershipActionButton = this.querySelector('#membership-action-button');
    if (membershipActionButton) {
      membershipActionButton.addEventListener('click', () => {
        const status = membershipActionButton.dataset.status;
        if (status === 'cancel') {
          this.cancelMembership(customerEmail);
        } else if (status === 'continue') {
          if (this.dataset.reactivateUrl) {
            window.location.href = this.dataset.reactivateUrl;
          } else {
            console.warn('Reactivate URL not found');
          }
        } else {
          this.reactivateMembership(customerEmail);
        }
      });
    }
  }

  fetchMembershipData(customerEmail) {
    axios
      .post(baseURL + 'get', {
        customerEmail: customerEmail,
      })
      .then((response) => {
        this.handleMembershipData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        if (error.response.data.message === 'Customer not found') {
          this.handleNoCustomer();
        }
      })
      .finally(() => {
        console.log('Request completed');
      });
  }

  handleMembershipData(data) {
    // Sort memberships by dateUpdated in descending order
    const sortedMemberships = data.data.sort((a, b) => new Date(b.dateUpdated) - new Date(a.dateUpdated));
    let activeMembershipFound = false;
    let firstMembershipProcessed = false;
    const membershipSummaryHeading = this.querySelector('#membership-summary-heading');
    const membershipStatus = this.querySelector('#membershipStatus');
    const membershipActionButton = this.querySelector('#membership-action-button');
    const customerName = this.querySelector('#customerName');
    const customerAddress = this.querySelector('#customerAddress');
    const customerBillingAddress = this.querySelector('#customerBillingAddress');
    const membershipPrice = this.querySelector('#membership-price');
    const membershipBillingDate = this.querySelector('#membership-billing-date');

    for (const membership of sortedMemberships) {
      const productIds = new Set([276, 278, 354, 279, 280, 355, 356, 357]);
      if (productIds.has(membership.base_product_id)) {
        // Display the product name for the first membership found
        if (!firstMembershipProcessed) {
          membershipSummaryHeading.textContent = this.formattedName(membership);
          this.dataset.purchaseId = membership.purchaseId;
          this.dataset.orderId = membership.orderId;
          firstMembershipProcessed = true;
        }

        if (membership.status === 'ACTIVE') {
          activeMembershipFound = true;
          this.dataset.purchaseId = membership.purchaseId;
          this.dataset.orderId = membership.orderId;
          if (customerName) {
            customerName.textContent = membership.customerName;
            customerName.classList.remove('hidden');
          }
          if (customerAddress) {
            customerAddress.textContent = membership.customerAddress;
            customerAddress.classList.remove('hidden');
          }
          if (customerBillingAddress) {
            customerBillingAddress.textContent = membership.customerAddress;
            customerBillingAddress.classList.remove('hidden');
          }
          if (membershipPrice) {
            membershipPrice.value = `$${membership.price}`;
            membershipPrice.parentElement.classList.remove('hidden');
          }
          if (membershipBillingDate) {
            let nextBillDate = new Date(membership.nextBillDate);
            let nextBillDateFormatted =
              (nextBillDate.getUTCMonth() + 1).toString() +
              '/' +
              nextBillDate.getUTCDate() +
              '/' +
              nextBillDate.getUTCFullYear().toString();
            membershipBillingDate.value = nextBillDateFormatted;
            membershipBillingDate.parentElement.classList.remove('hidden');
          }

          if (membershipActionButton) {
            membershipActionButton.textContent = 'Cancel Membership';
            membershipActionButton.dataset.status = 'cancel';

            if (customerBillingAddress) {
              customerBillingAddress.classList.remove('hidden');
            }
            if (customerAddress) {
              customerAddress.classList.remove('hidden');
            }
            if (membershipPrice) {
              membershipPrice.parentElement.classList.remove('hidden');
            }
            if (membershipBillingDate) {
              membershipBillingDate.parentElement.classList.remove('hidden');
            }

            if (membershipStatus) {
              membershipStatus.textContent = membership.status;
              membershipStatus.classList.add('membership-status-badge--active');
              membershipStatus.classList.remove('hidden');
            }
          }
          break; // Exit the loop after processing the active membership
        }
      }
    }

    if (!activeMembershipFound) {
      const membershipStatus = this.querySelector('#membershipStatus');
      const membershipActionButton = this.querySelector('#membership-action-button');
      // Handle the case where all memberships are canceled
      console.log('All memberships are canceled.');
      if (membershipActionButton) {
        membershipActionButton.textContent = 'Continue Membership';
        membershipActionButton.dataset.status = 'continue';
      }
      if (customerBillingAddress) {
        customerBillingAddress.classList.add('hidden');
      }
      if (customerAddress) {
        customerAddress.classList.add('hidden');
      }
      if (membershipPrice) {
        membershipPrice.classList.add('hidden');
      }
      if (membershipBillingDate) {
        membershipBillingDate.classList.add('hidden');
      }
      if (membershipStatus) {
        membershipStatus.textContent = 'Inactive';
        membershipStatus.classList.add('membership-status-badge--inactive');
        membershipStatus.classList.remove('hidden');
      }

      const hideOptions = document.querySelector('#membership-options');
      if (hideOptions) {
        hideOptions.classList.add('hidden');
      }
    }

    document.querySelector('#Loading').style.display = 'none';
    document.querySelector('#Loaded').style.display = 'block';
    const membershipOptions = document.querySelector('#membership-options');
    if (membershipOptions) {
      membershipOptions.style.display = 'block';
    }
  }

  formattedName(membership) {
    const productNameMap = {
      'Livingood Daily Lifestyle (Monthly)': 'Livingood Daily Lifestyle (Monthly)',
      'Livingood Daily Lifestyle (Monthly) Subscribe & Save': 'Livingood Daily Lifestyle (Monthly)',
      'Livingood Daily Lifestyle Trial': 'Livingood Daily Lifestyle (Monthly)',
      'Livingood Daily Lifestyle Free Trial': 'Livingood Daily Lifestyle (Monthly)',
      '$1 Livingood Daily Lifestyle 14-Day Trial': 'Livingood Daily Lifestyle (Monthly)',
      '$1 Livingood Daily Lifestyle 30-Day Trial': 'Livingood Daily Lifestyle (Monthly)',
      'Livingood Daily Lifestyle (Annual) Subscribe & Save': 'Livingood Daily Lifestyle (Annual)',
    };
    return productNameMap[membership.productName] || membership.productName;
  }

  cancelMembership(customerEmail) {
    const membershipModal = document.querySelector('membership-modal');
    if (membershipModal) {
      membershipModal.open();
    }
    console.log('Cancelling membership for:', customerEmail);
  }

  reactivateMembership(customerEmail) {
    console.log('Reactivating membership for:', customerEmail);
    const membershipModal = document.querySelector('membership-modal');
    if (membershipModal) {
      const videoModalContent = document.querySelector('#video-modal-content');
      if (videoModalContent) {
        videoModalContent.classList.add('hidden');
      }
      const cancelReasonsModalContent = document.querySelector('#cancel-reasons-modal-content');
      if (cancelReasonsModalContent) {
        cancelReasonsModalContent.classList.add('hidden');
      }
      const membershipModalTitle = document.querySelector('#membership-modal__title');
      if (membershipModalTitle) {
        membershipModalTitle.textContent = 'Are you sure you want to reactivate your membership?';
      }

      const keepMembershipButton = document.querySelector('#keep-membership');
      if (keepMembershipButton) {
        keepMembershipButton.innerHTML = `
          Close
          <span class="svg-wrapper">
            <span class="icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path></svg></span>
          </span>
        `;
      }

      const reactivateButton = document.querySelector('#reactivate-button');
      if (reactivateButton) {
        reactivateButton.classList.remove('hidden');
      }
      const continueButton = document.querySelector('#continue-button');
      if (continueButton) {
        continueButton.classList.add('hidden');
      }
      membershipModal.dataset.action = 'reactivate';
      membershipModal.open();
    }
  }
  handleNoCustomer() {
    const membershipSummaryHeading = this.querySelector('#membership-summary-heading');
    if (membershipSummaryHeading) {
      membershipSummaryHeading.textContent = 'No Membership Found';
    }
    const membershipActionButton = this.querySelector('#membership-action-button');
    if (membershipActionButton) {
      membershipActionButton.style.display = 'none';
    }
    document.querySelector('#Loading').style.display = 'none';
    document.querySelector('#Loaded').style.display = 'block';
  }
}

customElements.define('membership-actions', MembershipActions);
class MembershipDropdownMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.toggleDropdown.bind(this));
    window.addEventListener('click', this.closeDropdowns.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.toggleDropdown.bind(this));
    window.removeEventListener('click', this.closeDropdowns.bind(this));
  }

  toggleDropdown(event) {
    const listItem = event.target.closest('.membership-nav__item');
    if (!listItem) return;

    const dropdown = listItem.querySelector('.membership-nav__dropdown');
    const icon = listItem.querySelector('.membership-nav__icon');

    if (dropdown && event.target.closest('.membership-nav__link')) {
      event.preventDefault();
      event.stopPropagation();

      // Close all open dropdowns and reset icons except the current one
      const dropdowns = document.querySelectorAll('.membership-nav__dropdown');
      dropdowns.forEach((dd) => {
        if (dd !== dropdown && dd.classList.contains('membership-nav__dropdown--show')) {
          dd.classList.remove('membership-nav__dropdown--show');
          const openIcon = dd.previousElementSibling.querySelector('.membership-nav__icon');
          if (openIcon) {
            openIcon.classList.remove('membership-nav__icon--rotate');
          }
        }
      });

      // Toggle the clicked dropdown and rotate icon
      dropdown.classList.toggle('membership-nav__dropdown--show');
      if (icon) {
        icon.classList.toggle('membership-nav__icon--rotate');
      }

      // Adjust dropdown position only on mobile
      if (window.innerWidth < 768) {
        // Example threshold for mobile
        this.adjustDropdownPosition(dropdown, listItem);
      }
    }
  }

  adjustDropdownPosition(dropdown, listItem) {
    const listItemRect = listItem.getBoundingClientRect();
    const dropdownRect = dropdown.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    // Check if the dropdown overflows the viewport
    if (listItemRect.left + dropdownRect.width > viewportWidth) {
      dropdown.style.left = 'auto';
      dropdown.style.right = '0'; // Align to the right of the parent
    } else {
      dropdown.style.left = '0'; // Align to the left of the parent
      dropdown.style.right = 'auto';
    }
  }

  closeDropdowns(event) {
    if (!event.target.closest('.membership-nav__dropdown')) {
      const dropdowns = document.querySelectorAll('.membership-nav__dropdown');
      dropdowns.forEach((dd) => {
        if (dd.classList.contains('membership-nav__dropdown--show')) {
          dd.classList.remove('membership-nav__dropdown--show');
          const openIcon = dd.previousElementSibling.querySelector('.membership-nav__icon');
          if (openIcon) {
            openIcon.classList.remove('membership-nav__icon--rotate');
          }
        }
      });
    }
  }
}

customElements.define('membership-dropdown-menu', MembershipDropdownMenu);

class MembershipModal extends HTMLElement {
  constructor() {
    super();
    this.showOnLoad = this.dataset.showOnLoad === 'false';
    this.isOpen = false;

    // Bind methods
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.handleFinalContinue = this.handleFinalContinue.bind(this);
    this.handleKeepMembership = this.handleKeepMembership.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleReactivateMembership = this.handleReactivateMembership.bind(this);
  }

  connectedCallback() {
    if (this.showOnLoad) {
      this.open();
    }

    // Add event listeners
    const continueButton = this.querySelector('#continue-button');
    continueButton.addEventListener('click', this.handleContinue);

    const finalContinueButton = this.querySelector('#final-continue-button');
    if (finalContinueButton) {
      finalContinueButton.addEventListener('click', this.handleFinalContinue);
    }

    const finalCancelButton = this.querySelector('#final-cancel-button');
    if (finalCancelButton) {
      finalCancelButton.addEventListener('click', this.handleCancel);
    }

    const finalKeepMembershipButton = this.querySelector('#keep-membership');
    if (finalKeepMembershipButton) {
      finalKeepMembershipButton.addEventListener('click', this.handleKeepMembership);
    }

    const closeButton = this.querySelector('#membership-modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.handleClose.bind(this));
    }

    const reactivateButton = this.querySelector('#reactivate-button');
    if (reactivateButton) {
      reactivateButton.addEventListener('click', this.handleReactivateMembership);
    }
  }

  disconnectedCallback() {
    const continueButton = this.querySelector('#continue-button');
    continueButton.removeEventListener('click', this.handleContinue);

    const finalContinueButton = this.querySelector('#final-continue-button');
    if (finalContinueButton) {
      finalContinueButton.removeEventListener('click', this.handleFinalContinue);
    }

    const finalCancelButton = this.querySelector('#final-cancel-button');
    if (finalCancelButton) {
      finalCancelButton.removeEventListener('click', this.handleCancel);
    }

    const finalKeepMembershipButton = this.querySelector('#keep-membership');
    if (finalKeepMembershipButton) {
      finalKeepMembershipButton.removeEventListener('click', this.handleKeepMembership);
    }

    const closeButton = this.querySelector('#membership-modal__close-button');
    if (closeButton) {
      closeButton.removeEventListener('click', this.handleClose.bind(this));
    }

    const reactivateButton = this.querySelector('#reactivate-button');
    if (reactivateButton) {
      reactivateButton.removeEventListener('click', this.handleReactivate);
    }
  }

  open() {
    if (!this.isOpen) {
      this.setAttribute('open', '');
      document.body.classList.add('no-scroll');
      this.isOpen = true;
    }
  }

  close() {
    if (this.isOpen) {
      this.removeAttribute('open');
      document.body.classList.remove('no-scroll');
      this.isOpen = false;
      console.log('Modal closed');
    } else {
      console.log('Modal was already closed');
    }
  }
  handleClose() {
    this.close();
    this.resetModal();
  }

  handleContinue() {
    const cancelReasonsModalContent = this.querySelector('#cancel-reasons-modal-content');
    const videoModalContent = this.querySelector('#video-modal-content');
    cancelReasonsModalContent.classList.remove('hidden');
    videoModalContent.classList.add('hidden');
    this.querySelector('#final-continue-button').classList.remove('hidden');
    this.querySelector('#continue-button').classList.add('hidden');
  }

  handleFinalContinue() {
    // Logic for the final step
    const reasonRadio = this.querySelector('input[name="reason"]:checked');
    const otherReasonInput = this.querySelector('#otherReasonTextArea');
    let reason = reasonRadio ? reasonRadio.value : '';

    if (reason === 'Other') {
      this.querySelector('.membership-modal__cancel-reasons-radio').classList.add('hidden');
      this.querySelector('.membership-modal__cancel-reasons-text').classList.remove('hidden');

      otherReasonInput.classList.remove('hidden');
      this.querySelector('#final-cancel-button').classList.remove('hidden');
      this.querySelector('#final-continue-button').classList.add('hidden');
    } else {
      this.querySelector('.membership-modal__cancel-reasons-radio').classList.add('hidden');
      this.querySelector('#final-cancel-button').classList.remove('hidden');
      this.querySelector('#final-continue-button').classList.add('hidden');
    }
  }
  handleKeepMembership() {
    this.close();
    this.resetModal();
  }

  handleCancel() {
    console.log('Cancelling membership');
    this.handleMembershipAction('cancel');
    this.resetModal();
    this.close();
    this.toast('cancel');
  }

  toast(action) {
    console.log('action', action);
    var x = document.getElementById('toast');
    var desc = document.getElementById('desc');
    desc.textContent = action === 'cancel' ? 'Membership Cancelled' : 'Membership Reactivated';
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 10000);
  }

  resetModal() {
    // Reset the modal content to its initial state
    const cancelReasonsModalContent = this.querySelector('#cancel-reasons-modal-content');
    const videoModalContent = this.querySelector('#video-modal-content');
    const otherReasonInput = this.querySelector('#otherReasonTextArea');
    const finalStepContent = this.querySelector('#final-step-content');
    const continueButton = this.querySelector('#continue-button');
    const finalContinueButton = this.querySelector('#final-continue-button');
    const finalCancelButton = this.querySelector('#final-cancel-button');

    // Hide cancel reasons and final step content
    if (cancelReasonsModalContent) {
      cancelReasonsModalContent.classList.add('hidden');
    }
    if (finalStepContent) {
      finalStepContent.classList.add('hidden');
    }

    // Show initial video content
    if (videoModalContent) {
      videoModalContent.classList.remove('hidden');
    }

    // Reset the "Other" reason text area
    if (otherReasonInput) {
      otherReasonInput.value = '';
      otherReasonInput.classList.add('hidden');
    }

    // Reset button visibility
    if (continueButton) {
      continueButton.classList.remove('hidden');
    }
    if (finalContinueButton) {
      finalContinueButton.classList.add('hidden');
    }
    if (finalCancelButton) {
      finalCancelButton.classList.add('hidden');
    }

    // Reset radio buttons
    const reasonRadios = this.querySelectorAll('input[name="reason"]');
    reasonRadios.forEach((radio) => {
      radio.checked = false;
    });
  }

  async handleMembershipAction(event) {
    const membershipDetails = document.querySelector('#membership-actions');
    console.log('membershipDetails', membershipDetails);
    const purchaseId = membershipDetails.dataset.purchaseId;
    if (event == 'cancel') {
      let action = 'cancel';
      let cancelReason = '';
      let reason = this.querySelector('input[name="reason"]:checked').value;
      if (reason == 'Other') {
        cancelReason = this.querySelector('#otherReasonTextArea').value;
      } else {
        cancelReason = reason;
      }

      let data = {
        purchaseId: purchaseId,
        reason: cancelReason,
        action: action,
      };
      console.log('data', data);
      console.log('Cancelling membership');
      this.handleCancelMembership(data);
    }
  }
  handleCancelMembership(data) {
    console.log('data', data);
    console.log('Cancelling membership');

    axios
      .post(baseURL + 'cancel', data)
      .then((response) => {
        console.log(response);
        this.close();
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleReactivateMembership() {
    console.log('Reactivating membership');
    const membershipDetails = document.querySelector('#membership-actions');
    const purchaseId = membershipDetails.dataset.purchaseId;
    axios
      .post(baseURL + 'reactivate', {
        purchaseId: purchaseId,
      })
      .then((response) => {
        console.log(response);
        this.close();
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

customElements.define('membership-modal', MembershipModal);

// Define a custom element for membership options
class MembershipOptions extends HTMLElement {
  constructor() {
    super();
  }

  // Called when the element is added to the DOM
  connectedCallback() {
    const customerEmail = this.getAttribute('data-email');

    if (customerEmail) {
      console.log('customerEmail', customerEmail);
      this.fetchCustomerData(customerEmail); // Fetch customer data if email is present
    }

    // Add event listeners for address and card change buttons
    const changeAddressBtn = document.getElementById('changeAddress');
    if (changeAddressBtn) {
      changeAddressBtn.addEventListener('click', this.handleChangeAddress);
    }

    const changeCardBtn = document.getElementById('cardUrl');
    if (changeCardBtn) {
      changeCardBtn.addEventListener('click', this.handleChangeCardButton);
    }
  }

  // Called when the element is removed from the DOM
  disconnectedCallback() {
    const changeAddressBtn = document.getElementById('changeAddress');
    if (changeAddressBtn) {
      changeAddressBtn.removeEventListener('click', this.handleChangeAddress);
    }

    const changeCardBtn = document.getElementById('cardUrl');
    if (changeCardBtn) {
      changeCardBtn.removeEventListener('click', this.handleChangeCardButton);
    }
  }

  // Fetch customer data from the server
  fetchCustomerData(customerEmail) {
    axios
      .post(baseURL + 'customer/get', {
        customerEmail: customerEmail,
      })
      .then((response) => {
        this.handleAddress(response.data); // Handle address data
        this.handleCard(response.data); // Handle card data
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        console.log('Request completed');
      });
  }

  // Update the address information in the DOM
  handleAddress(address) {
    console.log('address', address);

    const billName = document.getElementById('customerAddressName');
    billName.textContent = address.data.firstName + ' ' + address.data.lastName;

    const billAddress1 = document.getElementById('customerAddress1');
    billAddress1.textContent = address.data.address1;

    const subscriptionBillingAddressMisc = document.getElementById('customerAddressMisc');
    subscriptionBillingAddressMisc.textContent = `${address.data.city}, ${address.data.postalCode}, ${address.data.state}, ${address.data.country}`;

    // Update modal fields with address data
    const modalFirstName = (document.getElementById('fname').value = address.data.firstName);
    const modalLastName = (document.getElementById('lname').value = address.data.lastName);
    const modalAddress1 = (document.getElementById('address1').value = address.data.address1);
    const modalAddress2 = (document.getElementById('address2').value = address.data.address2);
    const modalCity = (document.getElementById('city').value = address.data.city);
    const modalState = (document.getElementById('state').value = address.data.state);
    const modalZipCode = (document.getElementById('zipCode').value = address.data.postalCode);
    const modalCountry = (document.getElementById('country').value = address.data.country);

    const changeAddressBtn = document.getElementById('changeAddress');
    if (changeAddressBtn) {
      changeAddressBtn.dataset.customerId = address.data.customerId;
    }
  }

  // Update the card information in the DOM
  handleCard(card) {
    const last4 = document.getElementById('cardLast4');
    last4.textContent = `Card Ending in: ••••${card.data.cardLast4}`;

    const cardExpiry = document.getElementById('cardExpiry');
    let date = new Date(card.data.cardExpiryDate);
    const dateFormatted = (date.getUTCMonth() + 1).toString() + '/' + date.getUTCFullYear().toString();
    cardExpiry.textContent = `Card Expiry: ${dateFormatted}`;

    const changeCardDetailsBtn = document.getElementById('cardUrl');
    if (changeCardDetailsBtn) {
      changeCardDetailsBtn.dataset.customerId = card.data.customerId;
    }
  }

  // Handle the address change button click
  handleChangeAddress() {
    const membershipAddressModal = document.querySelector('membership-address-modal');
    if (membershipAddressModal) {
      membershipAddressModal.open(); // Open the address modal
    } else {
      console.error('Membership address modal not found');
    }
  }

  // Handle the card change button click
  handleChangeCardButton() {
    console.log('handleChangeCardButton');
    const cardUrl = 'https://hub2.livingooddaily.com/auth';
    const orderId = document.getElementById('membership-actions').dataset.orderId;
    const customerEmail = document.getElementById('membership-actions').dataset.email;
    window.open(`${cardUrl}?emailAddress=${customerEmail}&orderId=${orderId}`); // Open card URL in a new window
  }
}

// Define the custom element
customElements.define('membership-options', MembershipOptions);

// Define a custom element for the membership address modal
class MembershipAddressModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
  }

  // Called when the element is added to the DOM
  connectedCallback() {
    const closeButton = this.querySelector('#membership-address-modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this)); // Close modal on button click
    }

    const saveButton = this.querySelector('#membership-address-modal__save-button');
    if (saveButton) {
      saveButton.addEventListener('submit', this.handleSave.bind(this)); // Handle save button submit
    }

    const cancelButton = this.querySelector('#membership-address-modal__cancel-button');
    if (cancelButton) {
      cancelButton.addEventListener('click', this.close.bind(this)); // Close modal on cancel button click
    }

    const form = this.querySelector('#membership-address-form');
    if (form) {
      console.log('Form found, adding submit event listener');
      form.addEventListener('submit', this.handleFormSubmit.bind(this)); // Prevent form submission
    } else {
      console.error('Form not found');
    }
  }

  // Called when the element is removed from the DOM
  disconnectedCallback() {
    const closeButton = this.querySelector('#membership-address-modal__close-button');
    if (closeButton) {
      closeButton.removeEventListener('click', this.close.bind(this));
    }

    const cancelButton = this.querySelector('#membership-address-modal__cancel-button');
    if (cancelButton) {
      cancelButton.removeEventListener('click', this.close.bind(this));
    }

    const saveButton = this.querySelector('#membership-address-modal__save-button');
    if (saveButton) {
      saveButton.removeEventListener('submit', this.handleSave.bind(this));
    }
  }

  // Open the modal
  open() {
    if (!this.isOpen) {
      this.setAttribute('open', '');
      document.body.classList.add('no-scroll');
      this.isOpen = true;
      console.log('Address modal opened');
    }
  }

  // Close the modal
  close() {
    if (this.isOpen) {
      this.removeAttribute('open');
      document.body.classList.remove('no-scroll');
      this.isOpen = false;
      console.log('Address modal closed');
    } else {
      console.log('Modal was already closed');
    }
  }

  // Handle the save action
  handleSave() {
    console.log('Saving address');
  }

  // Prevent form submission and handle form data
  handleFormSubmit(event) {
    event.preventDefault();
    console.log(event.target);
    const changeAddressBtn = document.getElementById('changeAddress');
    let data = {
      billingFirstName: event.target.querySelector('#fname').value,
      billingLastName: event.target.querySelector('#lname').value,
      billingAddress1: event.target.querySelector('#address1').value,
      billingAddress2: event.target.querySelector('#address2').value,
      billingCity: event.target.querySelector('#city').value,
      billingState: event.target.querySelector('#state').value,
      billingZipCode: event.target.querySelector('#zipCode').value,
      billingCountry: event.target.querySelector('#country').value,
      customerId: changeAddressBtn?.dataset.customerId,
    };

    // Send updated address data to the server
    axios
      .post(baseURL + 'customer/update', data)
      .then((response) => {
        if (response.status === 200) {
          this.updateAddress(data); // Update address in the DOM
          this.close(); // Close the modal
          this.toast('update'); // Show a toast notification
        }
      })
      .catch((error) => {
        console.error('Error updating address:', error);
      });
    console.log('data', data);
  }

  // Update the address information in the DOM
  updateAddress(data) {
    const billName = document.getElementById('customerAddressName');
    billName.textContent = data.billingFirstName + ' ' + data.billingLastName;

    const billAddress1 = document.getElementById('customerAddress1');
    billAddress1.textContent = data.billingAddress1;

    const subscriptionBillingAddressMisc = document.getElementById('customerAddressMisc');
    subscriptionBillingAddressMisc.textContent = `${data.billingCity}, ${data.billingZipCode}, ${data.billingState}, ${data.billingCountry}`;

    // Update modal fields with new address data
    const modalFirstName = (document.getElementById('fname').value = data.billingFirstName);
    const modalLastName = (document.getElementById('lname').value = data.billingLastName);
    const modalAddress1 = (document.getElementById('address1').value = data.billingAddress1);
    const modalAddress2 = (document.getElementById('address2').value = data.billingAddress2);
    const modalCity = (document.getElementById('city').value = data.billingCity);
    const modalState = (document.getElementById('state').value = data.billingState);
    const modalZipCode = (document.getElementById('zipCode').value = data.billingZipCode);
    const modalCountry = (document.getElementById('country').value = data.billingCountry);
  }

  // Show a toast notification
  toast(action) {
    console.log('action', action);
    var x = document.getElementById('toast');
    var desc = document.getElementById('desc');
    desc.textContent = action === 'update' ? 'Address Updated' : 'Membership Reactivated';
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 10000);
  }
}

// Define the custom element
customElements.define('membership-address-modal', MembershipAddressModal);

// Utility function to validate US ZIP codes
function isUSAZipCode(str) {
  return /^\d{5}(-\d{4})?$/.test(str);
}

// Validate input and display a message
function validateInput() {
  console.log('validateInput');
  let zipCode = document.getElementById('zipCode').value;
  let message = '';
  if (isUSAZipCode(zipCode)) {
    message = 'Valid Zip Code';
  } else {
    message = 'Invalid Zip Code';
  }
  document.getElementById('msg').innerHTML = message;
}
